'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { debounce } from '@bridge/utils';
import { useSearchParams } from 'next/navigation';
import { Input } from '../../components';
import { useTableFilters } from '../useTableFilters';
import type { ComponentProps } from 'react';
import type { BaseTableFilterProps } from './types';
export interface InputTableFilterProps extends BaseTableFilterProps {
  searchParam: string;
  variant: 'input';
  componentProps?: Partial<ComponentProps<typeof Input>>;
  placeholder?: string;
  value?: string;
  containerClassName?: string;
  filterOptions?: never;
  groups?: never;
  fromDateParam?: never;
  toDateParam?: never;
}
export function InputTableFilter(t0) {
  const $ = _c(18);
  const {
    className,
    containerClassName,
    searchParam,
    searchParamsToClearOnChange,
    componentProps,
    placeholder,
    value,
    filterType: t1
  } = t0;
  const filterType = t1 === undefined ? "rsc" : t1;
  const searchParams = useSearchParams();
  const {
    updateFilterValue
  } = useTableFilters(filterType);
  const [selectedValue, setSelectedValue] = useState(value || "");
  let t2;
  let t3;
  if ($[0] !== searchParam || $[1] !== searchParams || $[2] !== value) {
    t2 = () => {
      const urlValue = searchParams?.get(searchParam) || value || "";
      setSelectedValue(urlValue);
    };
    t3 = [searchParams, searchParam, value];
    $[0] = searchParam;
    $[1] = searchParams;
    $[2] = value;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  const debouncedUpdateRef = useRef(null);
  let t4;
  let t5;
  if ($[5] !== searchParam || $[6] !== searchParamsToClearOnChange || $[7] !== updateFilterValue) {
    t4 = () => {
      debouncedUpdateRef.current = debounce(value_0 => {
        updateFilterValue(searchParam, value_0, searchParamsToClearOnChange);
      }, 350) as (value: string) => void;
    };
    t5 = [searchParam, searchParamsToClearOnChange, updateFilterValue];
    $[5] = searchParam;
    $[6] = searchParamsToClearOnChange;
    $[7] = updateFilterValue;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = value_1 => {
      setSelectedValue(value_1);
      debouncedUpdateRef.current?.(value_1);
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const handleChange = t6;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = e => handleChange(e.target.value);
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== className || $[13] !== componentProps || $[14] !== containerClassName || $[15] !== placeholder || $[16] !== selectedValue) {
    t8 = <Input className={className} containerClassName={containerClassName} onChange={t7} placeholder={placeholder} value={selectedValue} {...componentProps} />;
    $[12] = className;
    $[13] = componentProps;
    $[14] = containerClassName;
    $[15] = placeholder;
    $[16] = selectedValue;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}